import React from 'react'
import { Trans } from 'react-i18next'
import { useInsightContentData } from 'hooks/useInsightModalState'
import { CountTypeStrings } from 'enums/CountType'
import { InsightContentSettingType } from 'components/insightContent/types'
import SparklineOverview from 'components/insightContent/visualization/Overview/SparklineOverview'
import { getMeasureTypeByCountType } from 'components/insightContent/utils/utils'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { MessageConst } from 'enums'
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'

import RunSearchEffect from './RunSearchEffect'

const StyledName = styled.span.attrs({
  [AUTO_ATTR_KEY]: AutomationId.insightModal.insightContent.overview.selectedTerm
})`
  font-weight: ${sys.fontWeight.semibold};
  margin-left: 3px;
  margin-right: 3px;
`

const OverallSurveyScoresAverage = ({
  detailSetting,
  countType
}: {
  detailSetting: InsightContentSettingType
  countType: CountTypeStrings
}) => {
  const insightContent = useInsightContentData(InsightContentType.OVERALL_SURVEY_SCORES_AVERAGE)
  const noValue = detailSetting.insights?.[0]?.overallSurveyScoresAverage === -1

  return (
    <UnexpectedErrorBoundary>
      <RunSearchEffect detailSetting={detailSetting}>
        <SparklineOverview
          title={
            <Trans
              i18nKey="overallSurveyScoreAverageWith"
              values={{
                name: detailSetting.selectionName
              }}
              components={{
                CustomTag: <StyledName />
              }}
            />
          }
          count={
            noValue
              ? MessageConst.EM_DASH
              : insightContent?.data?.[0]?.results?.[0]?.data?.metrics?.[0]?.dataset?.[0]?.set?.[0]
          }
          sparklineData={
            noValue
              ? undefined
              : insightContent?.data?.[0]?.results?.[0]?.data?.metrics?.[1]?.dataset?.[0]?.set
          }
          measureType={getMeasureTypeByCountType(countType)}
          status={insightContent?.status}
        />
      </RunSearchEffect>
    </UnexpectedErrorBoundary>
  )
}

export default OverallSurveyScoresAverage
